<div class="landing-page">
    <div class="landing-container">
        <img class="pop-logo"
             src="./assets/images/jovacopop.svg" />
        <div class="pop-display-flex landing-content">
            <div class="left-landing-content">
                <h1>
                    {{ "LANDING_CONTENT.WELCOME" | translate }},<br />
                    {{ currentUser?.name }}
                </h1>
                <p translate="LANDING_CONTENT.DESC"></p>

                <button class="estimations-btn"
                        *ngIf="allowedAccessEstimationModule && isEstimateListRestricted"
                        [routerLink]="['/app/estimate-list']"
                        translate="LANDING_CONTENT.ESTIMATIONS_BTN">
                </button>

                <p class="warning-no-modules"
                   *ngIf="initCompleted && !allowedAccessEstimationModule"
                   translate="ERROR.LICENSE_NO_MODULES"></p>
            </div>
        </div>
    </div>
    <div class="pop-svg-container">
        <img class="pop-svg"
             src="../../../assets/images/whiteborder.svg">
    </div>
</div>
